import React from 'react';
import { TemplateIcon } from 'components/templates/template-icon';
import { useSourceClinicalMeetingSubjects } from 'components/hooks';
import { CircularProgress } from '@mui/material';

interface Props {
  meetingSubjectsID: string;
}

export const TemplateClinicalMeetingSubject: React.FC<React.PropsWithChildren<Props>> = ({
  meetingSubjectsID,
}) => {
  const { map } = useSourceClinicalMeetingSubjects();
  const meeting = map[meetingSubjectsID];

  if (!meeting) {
    return <CircularProgress />;
  }

  return (
    <TemplateIcon
      color={meeting?.color}
      iconSrc={meeting?.icon}
      sx={{ minHeight: '4rem', minWidth: '4rem' }}
      AvatarProps={{
        title: meeting?.title,
      }}
    />
  );
};
